import { useTheme } from '@mui/material/styles'
import { CSSProperties, MouseEvent, ReactElement } from 'react'

export interface BlockOverlayProps {
  isUiBlocked?: boolean
  blockedOverlayClick?: (event: MouseEvent<HTMLDivElement>) => void
  blockedOverlayLeftOffset?: number
  blockedOverlayRightOffset?: number
  blockedOverlayTopOffset?: number
  blockedOverlayBottomOffset?: number
  color?: string
  opacity?: number
  zIndex?: number
  id?: string
}

export default function BlockOverlay({
  isUiBlocked,
  blockedOverlayClick,
  blockedOverlayLeftOffset: leftOffset,
  blockedOverlayRightOffset: rightOffset,
  blockedOverlayTopOffset: topOffset,
  blockedOverlayBottomOffset: bottomOffset,
  color,
  opacity,
  zIndex,
  id
}: BlockOverlayProps): ReactElement {
  const theme = useTheme()
  const overlayStyle: CSSProperties = {
    position: 'absolute',
    visibility: isUiBlocked ? 'visible' : 'hidden',
    opacity: opacity ?? (isUiBlocked ? 0.5 : 0.0),
    background: color ?? theme.palette.border.primary,
    top: topOffset ?? 0,
    bottom: bottomOffset ?? 0,
    right: rightOffset ?? 0,
    left: leftOffset ?? 0,
    zIndex: zIndex ?? -1,
    overflow: 'hidden',
    cursor: 'not-allowed',
    borderRadius: '5px',
    pointerEvents: isUiBlocked && blockedOverlayClick ? 'all' : 'none'
  }

  return <div id={id} style={overlayStyle} onClick={blockedOverlayClick} />
}
